export const dp_r2 = '0.125rem';
export const dp_r4 = '0.25rem';
export const dp_r8 = '0.5rem';
export const dp_r12 = '0.75rem';
export const dp_r16 = '1rem';
